import type { FaireProductEntity } from "../../entity_types/product";

export const p_ymn8hxwaqw: FaireProductEntity = {
  token: "p_ymn8hxwaqw",
  type: "product",
  name: "Halloween Eye Candy Hydrating Undereye masks - 6 Pairs",
  brandToken: "b_or0vvyanpz",
  brandName: "My Spa Life",
  imageUrl:
    "https://cdn.faire.com/fastly/db1148d65d5b0847590a087393649e21ffe9e85168bf79b4ff184cfe67d4b57f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/f904da6a7646e8de23e1c4e0c97f5effc2b65ef29518ffdf9d0753657804fcf8.jpeg",
    "https://cdn.faire.com/fastly/09604ba2109843a39c87e92a6b5a157e7a1a78630d098d116c2c2a2683e63e63.jpeg",
    "https://cdn.faire.com/fastly/5d7a5d21dc4ddf9a347ff60a800d0db5ecaec7dc437208c9b9c9790216cfa64f.jpeg",
  ],
  priceDollars: 3.5,
  description:
    "Treat yourself to sweet Halloween skincare with candy-shaped hydrogel undereye masks. Infused with vitamin C, hyaluronic acid & plant collagen, these cute eye masks brighten dark circles, plump hydration & refresh tired eyes. A festive pick for fall self-care, Halloween gifts, or boo basket stuffers.\n\n𝐖𝐡𝐲 𝐖𝐞 𝐋𝐨𝐯𝐞 𝐈𝐭:\n• Vitamin C brightens dull undereyes\n• Hyaluronic acid locks in hydration\n• Plant collagen smooths fine lines\n• Candy design adds spooky-cute fun\n\n𝐁𝐞𝐧𝐞𝐟𝐢𝐭𝐬: fades discoloration, hydrates, de-puffs\n\n𝐇𝐨𝐰 𝐓𝐨 𝐔𝐬𝐞:\n• Apply to clean, dry undereye area\n• Leave on 15–20 mins\n• Remove & discard after use\n• Massage serum until absorbed",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:32.441Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
